import angular from 'angular';
import 'angular-animate';
import 'angular-resource';
import 'angular-sanitize';
import 'angular-route';
import 'angular-strap';
import 'angular-strap/dist/angular-strap.tpl';
import 'ng-dialog';
import './controllers.js';
import './directives.js';
import 'bootstrap';
import 'js/services';
import 'js/filters';
import EventsLoggingService from 'js/EventsLoggingService';

import '../css/vendor/animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'ng-dialog/css/ngDialog.css';
import 'ng-dialog/css/ngDialog-theme-default.css';
import 'ng-dialog/css/ngDialog-theme-plain.css';
import '../css/vendor/rzslider.css';
import '../css/vendor/angular-toggle-switch.css';
import '../css/myp.css';
import '../css/myp-top-bar.css';
import '../css/myp-sidebar-tabs.css';

EventsLoggingService.initialize();

var myp = angular.module('myp', ['myp.services', 'myp.controllers', 'myp.directives', 'myp.filters', 'ui.router', 'ngRoute', 'ngAnimate', 'ngSanitize', 'ngDialog', 'mgcrea.ngStrap']);

//Constant used to check users credentials
myp.constant('AUTH_EVENTS', {
    loginSuccess: 'auth-login-success',
    loginFailed: 'auth-login-failed',
    logoutSuccess: 'auth-logout-success',
    sessionTimeout: 'auth-session-timeout',
    authenticatedSuccess: 'auth-authenticated',
    notAuthenticated: 'auth-not-authenticated',
    notAuthorized: 'auth-not-authorized',
    platformAuthentication: 'platform-authorized'
});

//Constant used to check users privileges
myp.constant('USER_ROLES', {
    ALL: '*',
    ADMIN: 'ADMIN',
    EARLY: 'EARLY',
    ADOPT: 'ADOPT',
    BETA: 'BETA',
    PRO: 'PRO',
    GUEST: 'GUEST',
    TRIAL: 'TRIAL',
    PREM: 'PREM'
});

myp.config(function ($httpProvider) {

    var logsOutUserOn401 = function ($location, $q, flashService) {
        var success = function (response) {
            return response;
        };

        var error = function (response) {
            if (response.status === 401) {
                $location.path('/login');
                flashService.show(response.data.flash);
            }
            return $q.reject(response);
        };

        return function (promise) {
            return promise.then(success, error);
        };
    };
    $httpProvider.responseInterceptors.push(logsOutUserOn401);

    delete $httpProvider.defaults.headers.common['X-Requested-With'];
});

myp.config(['$routeProvider', '$locationProvider', 'USER_ROLES', '$stateProvider',
    function ($routeProvider, $locationProvider, USER_ROLES, $stateProvider) {
        $routeProvider.
            when('/', {
                data: {
                    authorizedRoles: [USER_ROLES.ALL]
                }
            }).when('/by-law', {
                controller: 'ByLawCtrl',
                templateUrl: '/views/zoning_sidebar.html',
                data: {
                    authorizedRoles: [USER_ROLES.ADMIN]
                }
            }).when('/report', {

            }).when('/water', {
                controller: 'WaterCtrl',
                templateUrl: '/views/water_sidebar.html'
            }).when('/environment', {
                controller: 'EnivronCtrl',
                templateUrl: '/views/environment_sidebar.html'
            }).when('/provincial-plan', {
                controller: 'ProvincialCtrl',
                templateUrl: '/views/provincial_plan_sidebar.html'
            }).when('/official-plan', {
                controller: 'OfficialCtrl',
                templateUrl: '/views/oplu_sidebar.html'
            }).when('/dev-app-toronto', {
                controller: 'devapp_sidebarCtrl',
                templateUrl: '/views/devapp_sidebar.html'
            }).when('/op-citywide-toronto', {
                controller: 'CityWideCtrl',
                templateUrl: '/views/municipal_plan_sidebar.html'
            }).when('/report', {

            }).when('/report-access', {

            }).when('/prime', {
                controller: 'PrimeCtrl',
                templateUrl: '/views/prime.html'
            }).when('/home', {
                controller: 'homeCtrl',
                templateUrl: '/views/home.html'
            }).when('/login', {
                templateUrl: '/views/prime.html'
            }).when('/resetpassword', {

            }).when('/forgot', {

            }).when('/register', {
                templateUrl: '/views/prime.html'
            }).when('/tutorial1', {

            }).when('/trial-success', {
                reloadOnSearch: false
            });
        $locationProvider.html5Mode(false);
    }]);

myp.config(['$tooltipProvider',
    function ($tooltipProvider) {
        angular.extend($tooltipProvider.defaults, {
            //html: true
        })
    }]);

myp.run(function ($rootScope, $location, authenticationService, flashService, ngDialog, AUTH_EVENTS, USER_ROLES) {
    $rootScope.authorizedRoles = "";//Set authorized roles for prime content & free content
    $rootScope.userPath = '';//Hold users previous route path when they do stuff like click Planning Report or Login
    if ($location.absUrl().indexOf('address') != -1) {
        var path = $location.absUrl();
        var index = $location.absUrl().indexOf('=');
        path = path.slice(index + 1);
        var res = path;
        while (res.indexOf('%20') != -1)
            res = res.replace('%20', ' ');
        /*while(res.indexOf('') != -1)
            res = res.replace('20',' ');*/
        path = res;
        $rootScope.searchedPath = path;
    }
    $rootScope.$on('$routeChangeStart', function (event, next, current) {
        //Check if user is signed in already
        authenticationService.getUserCookie().then(function (data) {
            if (data.data.flash) {
                //console.log(data.data.flash);
            }
            else {
                $rootScope.currentUser = data.data;
                if ($location.path() == '/prime') {
                    $location.path($rootScope.userPath);
                }
                else if ($location.path() == '/report-access') {
                    if (!authenticationService.isAuthorized($rootScope.authorizedRoles)) {

                    } else {
                        $location.path('/report');
                    }
                }
            }
        });
    });

    $rootScope.$on('$locationChangeStart', function (event, next, current) {
        if ($location.path() == '/official-plan' || $location.path() == '/by-law' || $location.path() == '/water' || $location.path() == '/environment' || $location.path() == '/provincial-plan' || $location.path() == '/op-citywide-toronto') {
            $rootScope.authorizedRoles = [USER_ROLES.ADMIN, USER_ROLES.ADOPT, USER_ROLES.BETA, USER_ROLES.PRO, USER_ROLES.TRIAL, USER_ROLES.EARLY, USER_ROLES.PREM];
        } else if ($location.path() == '/report') {
            $rootScope.authorizedRoles = [USER_ROLES.ADMIN, USER_ROLES.BETA, USER_ROLES.PRO, USER_ROLES.TRIAL, USER_ROLES.EARLY, USER_ROLES.PREM];
        } else if ($location.path() == '/dev-app-toronto') {
            $rootScope.authorizedRoles = [USER_ROLES.ADMIN, USER_ROLES.EARLY, USER_ROLES.PREM, USER_ROLES.BETA, USER_ROLES.TRIAL];
        } else {
            $rootScope.authorizedRoles = [USER_ROLES.ADMIN, USER_ROLES.EARLY, USER_ROLES.GUEST, USER_ROLES.ADOPT];
        }
        if (!authenticationService.isAuthorized($rootScope.authorizedRoles) && ($location.path() == '/official-plan' || $location.path() == '/by-law' || $location.path() == '/water' || $location.path() == '/environment' || $location.path() == '/provincial-plan' || $location.path() == '/dev-app-toronto' || $location.path() == '/op-citywide-toronto')) {
            //event.preventDefault();
            $rootScope.userPath = $location.path();

            $location.path('/prime');
            $rootScope.$broadcast('handleBroadcast');

            if (authenticationService.isAuthenticated()) {
                //user is not allowed
                $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
            } else {
                //user is not logged in
                $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
            }
        } else if (!authenticationService.isAuthorized($rootScope.authorizedRoles) && $location.path() == '/report') {
            //event.preventDefault();
            $rootScope.userPath = $location.path();

            if (authenticationService.isAuthenticated()) {
                //user is not allowed
                $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
            } else {
                //user is not logged in
                $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
            }

            $location.path('/report-access');

            if (!$rootScope.isAccess) {
                $rootScope.isAccess = true;
                //Activate the report dialog
                $rootScope.accessDialog = ngDialog.open({
                    templateUrl: '/templates/report-access.html',
                    controller: 'ReportCtrl',
                    className: 'ngdialog-theme-default'
                });
                $rootScope.accessDialog.closePromise.then(function (data) {
                    $rootScope.isAccess = false;
                    $location.path('');
                });
            }

        } else if ($location.path() == '/report') {
            /*$rootScope.reportDialog = ngDialog.open({
            templateUrl:'/templates/report-console.html',
            controller:'ReportCtrl',
            className: 'ngdialog-theme-default',
            closeByEscape: true,
            closeByDocument: false,
            showClose: false
        });
            $rootScope.reportDialog.closePromise.then(function (data) {
                $location.path($rootScope.userPath);
            });
            $rootScope.$broadcast('closeSidebar');
            //Activate the report dialog
            $rootScope.reportDialog = ngDialog.open({
                templateUrl:'/templates/report-console.html',
                controller:'ReportCtrl',
                className: 'ngdialog-theme-default',
                closeByEscape: true,
                closeByDocument: false,
                showClose: false
            });
            $rootScope.reportDialog.closePromise.then(function (data) {
                $location.path($rootScope.userPath);
            });*/
        }
    });
});



// WEBPACK FOOTER //
// ./public/js/app.js